import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-delete-folder-confirmation',
  templateUrl: './delete-folder-confirmation.component.html',
  styleUrls: ['./delete-folder-confirmation.component.scss'],
  standalone: false
})
export class DeleteFolderConfirmationComponent implements OnInit {
  @Input() group = null;
  @Input() currentPrintProduct = null;

  constructor(protected modalController: ModalController) {
  }

  ngOnInit() {
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    this.modalController.dismiss(({
      remove: true,
    }));
  }
}
